import React from "react";
import styled from "styled-components";
import { Result, Button } from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleContactSupport = () => {
    navigate("/contact");
  };

  return (
    <Container>
      <Result
        icon={<LockOutlined style={{ color: "#ff4d4f" }} />}
        title="Access Denied"
        subTitle={
          <div>
            <p>You need a secure access link to view this chat.</p>
            <p>
              Please use the link provided in your welcome email or contact your
              landlord.
            </p>
          </div>
        }
        extra={[
          <StyledContactButton
            type="primary"
            onClick={handleContactSupport}
            key="contact"
          >
            Contact Support
          </StyledContactButton>,
          <Button onClick={() => navigate("/")} key="home">
            Go Home
          </Button>,
        ]}
      />
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 2rem;
`;

const StyledContactButton = styled(Button)`
  height: 44px !important;
  padding: 0 24px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: var(--color-primary) !important;
  border-color: var(--color-primary) !important;

  &:hover {
    background: var(--color-primary-dark) !important;
    border-color: var(--color-primary-dark) !important;
  }

  .anticon {
    color: white !important;
  }
`;

export default AccessDenied;
